<template>
  <div class="punch-code">
    <main>
      <p>You've been invited to participate in this event.<br>
      To enter please enter the provided code.</p>

      <div class="outer">
        <div class="inner">
          <input type="text" min="0" max="99999"
            class="code-field"
            maxlength="5" 
            :class="{ fail: fail }"
            ref="code"
            v-model="code"
            autocomplete="one-time-code">
        </div>
      </div>
      <div v-if="fail" class="fail">
        This code is invalid.<br>
        Please <span @click="tryAgain">try again</span>.
      </div>

      <router-link to="/reader" class="to-qr"><i class="material-icons">smartphone</i> Looking at a QR code?</router-link>

      <div class="demo">
        <h5>For demo purposes, use one of the following codes:</h5>
        <strong>12345</strong> | <em>Match operations (UEFA MOC)</em><br>
        <strong>11111</strong> | <em>Approach to stadium (UEFA EURO Tournaments)</em><br>
        <strong>22222</strong> | <em>Pyrotechnics training on the job (Clubs)</em><br>
        <strong>54321</strong> | <em>Plenary scenario (UEFA stadium & security events)</em>
      </div>

    </main>
    <img src="@/assets/background-code.svg" class="background" alt="Log in" />
  </div>
</template>

<script>
export default {
  name: 'PunchCode',
  data () {
    return {
      code: '',
      fail: false
    }
  },
  created () {
    this.$store.dispatch('traineeStatusModule/authorize', false)
  },
  methods: {
    tryAgain () {
      this.code = ''
      this.fail = false
      this.$refs.code.focus()
    },
    setCaretPosition(elem, caretPos) {
      if(elem != null) {
        if(elem.createTextRange) {
          var range = elem.createTextRange();
          range.move('character', caretPos);
          range.select();
        }
        else {
          if(elem.selectionStart) {
            elem.focus();
            elem.setSelectionRange(caretPos, caretPos);
          }
          else {
            elem.focus();
          }
        }
      }
    }
  },
  watch: {
    code (val) {
      let obj = this.$refs.code
      if (val.length > 4){
        this.setCaretPosition(obj, 0);

        if ( val === '12345' ) {
          this.$store.dispatch('traineeStatusModule/authorize', true)
          this.$router.push({ path: '/trainee/scenario/10/playlist/w1' })
        } else if (val === '11111') {
          this.$store.dispatch('traineeStatusModule/authorize', true)
          this.$router.push({ path: '/trainee/scenario/12/playlist/a1' })
        } else if (val === '54321') {
          this.$store.dispatch('traineeStatusModule/authorize', true)
          this.$router.push({ path: '/trainee/scenario/3/playlist/pl1' })
        } else if (val === '22222') {
          this.$store.dispatch('traineeStatusModule/authorize', true)
          this.$router.push({ path: '/trainee/scenario/13/playlist/p1' })
        } else {
          this.fail = true
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.punch-code {
  position: relative;
  max-width: var(--container-width);
  margin: 0 auto;
  display: grid;
  grid-gap: 0;
  grid-template-areas:
    "smain"
    "sfooter";
  grid-template-columns: 1fr;
  grid-template-rows: minmax(500px, auto) 50px;

  main {
    grid-area: smain;
    // background-color: #c9c9c9;
    padding: 20px;
    display: flex;
    flex-direction: column;

    p {
      font-size: 24px;
      font-weight: bold;
      color: #1d04b4;
    }
    .fail {
      color: red;
      margin-bottom: 1em;

      span {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .demo {
      margin-top: auto;
      // border: 1px dashed #000;
      padding: 10px;
      max-width: 500px;
      background-color: rgba(255, 255, 255, 0.7);

      h5 {
        font-size: 1rem;
        margin-bottom: 0.7em;
      }
    }
  }

  .code-field {
    font-family: 'Roboto Mono', monospace;
    padding-left: 10px;
    letter-spacing: 37px;
    font-size: 39px;
    border: 0;
    background-image: linear-gradient(to left, #e2e8ff 70%, rgba(255, 255, 255, 0) 0%);
    background-position: bottom;
    background-size: 60px 100%;
    background-repeat: repeat-x;
    background-position-x: -18px;
    background-color: transparent;
    width: 282px;
    min-width: 282px;
    margin-bottom: 0.5em;
    color: #1d04b4;

    &:focus {
      outline: none;
    }

    &.fail {
      background-image: linear-gradient(to left, rgb(252, 228, 228) 70%, rgba(255, 255, 255, 0) 0%);
    }
  }

  .inner{
    left: 0;
    position: sticky;
  }

  .outer {
    width: 282px; 
    overflow: hidden;
  }

  footer {
    grid-area: sfooter;
  }

  aside {
    grid-area: saside;
    background-color: #c9c9c9;
    overflow: hidden;
    position: relative;
  }
  .to-qr {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #1d04b4;

    i {
      margin-right: 10px;
    }
  }

  .background {
    z-index: -1;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 70%;
  }
}
</style>
